<h3 class="with-horizontal-padding">{{ 'LBL.NOTIFICATIONS' | translate }}</h3>
<mat-divider></mat-divider>
<div class="scrollable-content-wrapper" fxFlex>
  <mat-list class="scrollable-content">
    <mat-list-item class="item-row auto-height" *ngFor="let alert of messages">
      <div fxLayoutGap="8px" fxLayout="row">
        <!-- <mat-icon>notifications_none</mat-icon> -->
        <img class="not-icon" src="assets/images/mnt3.svg" />
        <div fxLayoutGap="4px" fxLayout="column">
          <h4 class="no-margin">{{ alert?.subject }}</h4>
          <p class="notification-body">
            {{ alert?.message }}
          </p>
        </div>
      </div>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>
</div>
